import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        token: null
    },
    mutations: {
        // 登录
        login(state, token) {
            state.token = token;
            localStorage.setItem("authToken", token);
        },
        // 退出
        logout() {
            localStorage.clear()
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js